import { useState, useEffect } from 'react';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/5d4b6d7972e2a20db595a07764aede5e.jpg',
      title: 'お子様の可能性を信じて',
      subtitle: '一人ひとりに寄り添った療育を提供します',
      cta: '詳しく見る'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20therapists%20working%20with%20children%20in%20bright%20therapy%20room%2C%20specialized%20educational%20activities%2C%20warm%20supportive%20environment%2C%20modern%20facilities%2C%20natural%20lighting%2C%20caring%20interaction%2C%20developmental%20support%20setting&width=1920&height=800&seq=hero2&orientation=landscape',
      title: '専門スタッフによる支援',
      subtitle: '経験豊富なスタッフがお子様の成長をサポート',
      cta: 'スタッフ紹介'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Japanese%20children%20engaged%20in%20group%20activities%20and%20learning%20together%20in%20colorful%20daycare%20center%2C%20social%20interaction%2C%20educational%20games%2C%20bright%20cheerful%20environment%2C%20natural%20lighting%2C%20inclusive%20atmosphere%2C%20developmental%20support&width=1920&height=800&seq=hero3&orientation=landscape',
      title: '充実したプログラム',
      subtitle: '個別支援から集団療育まで多様なプログラム',
      cta: 'プログラム一覧'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center text-white px-4 sm:px-6 max-w-4xl">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 md:mb-6 drop-shadow-lg">
                {slide.title}
              </h2>
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-8 drop-shadow-lg">
                {slide.subtitle}
              </p>
              <button className="bg-white text-blue-600 px-6 sm:px-8 py-2 sm:py-3 text-sm sm:text-base rounded-lg font-semibold hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap shadow-lg">
                {slide.cta}
              </button>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Dots */}
      <div className="absolute bottom-4 sm:bottom-6 md:bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2 sm:space-x-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide
                ? 'bg-white w-6 sm:w-8'
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={() => goToSlide((currentSlide - 1 + slides.length) % slides.length)}
        className="absolute left-2 sm:left-4 top-1/2 transform -translate-y-1/2 bg-white/30 hover:bg-white/50 text-white p-2 sm:p-3 rounded-full transition-colors cursor-pointer"
        aria-label="Previous slide"
      >
        <i className="ri-arrow-left-s-line text-xl sm:text-2xl"></i>
      </button>
      <button
        onClick={() => goToSlide((currentSlide + 1) % slides.length)}
        className="absolute right-2 sm:right-4 top-1/2 transform -translate-y-1/2 bg-white/30 hover:bg-white/50 text-white p-2 sm:p-3 rounded-full transition-colors cursor-pointer"
        aria-label="Next slide"
      >
        <i className="ri-arrow-right-s-line text-xl sm:text-2xl"></i>
      </button>
    </div>
  );
};

export default HeroSlider;
